import { render, staticRenderFns } from "./DialogInviteCode.vue?vue&type=template&id=2315a82f&scoped=true"
import script from "./DialogInviteCode.vue?vue&type=script&lang=js"
export * from "./DialogInviteCode.vue?vue&type=script&lang=js"
import style0 from "./DialogInviteCode.vue?vue&type=style&index=0&id=2315a82f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315a82f",
  null
  
)

export default component.exports